/*
 * @Description: 404
 * @Author: zhongshanxian01
 * @Date: 2022-12-02 14:07:28
 * @LastEditors: zhongshanxian01
 * @LastEditTime: 2022-12-07 10:27:02
 */
import React from 'react';
export default function Custom404() {
    return (
        <div className="not-found">
            <div className="page-inner">
                <p>您访问的页面不存在哦</p>
            </div>
        </div>
    );
}
